export const BREAK_POINT_MIN = 360;
export const BREAK_POINT_TABLET = 768;
export const BREAK_POINT_MAX = 1140;
export const BANGLA_NUMBER_ARRAY = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];

export const MEDIA_TABLET = "(min-width: " + BREAK_POINT_TABLET + ")";

export const GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.mcc.prothomalo&hl=en_IN";
export const APPLE_PLAYSTORE = "https://apps.apple.com/us/app/bangla-newspaper-prothom-alo/id548596669";

export const listValue = [
  { key: "bangla", value: "বাংলা" },
  { key: "english", value: "English" },
  { key: "north-america", value: "উত্তর আমেরিকা" }
];

export const storyTemplatesList = [
  { key: "all", value: "All" },
  { key: "text", value: "Text" },
  { key: "photo", value: "Photo" },
  { key: "video", value: "Video" },
  { key: "live-blog", value: "Live-Blog" },
  { key: "gallery", value: "Gallery" },
  { key: "breaking-news", value: "Breaking News" },
  { key: "polls", value: "Polls" }
];

export const sortingList = [
  { key: "default", value: "Default" },
  { key: "latest-published", value: "Latest" },
  { key: "published-at:asc", value: "Oldest" }
];
